import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector, connect } from "react-redux";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import SVG from "react-inlinesvg";
import { makeStyles } from "@material-ui/core/styles";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { smallGroupGet } from "../../../../redux/actions";
import _Edit from "../../../images/edit.svg";
import _Close from "../../../images/close.svg";
import DynamicForm, {
  DynamicSection,
  COMPONENT_TYPES,
} from "../../../../core/generic-form";
import formDataHandler from "../../../util/formDataHandler";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  input: {
    display: "none",
  },
}));
let FilterForm = (props) => {
  const classes = useStyles();
  const selector = formValueSelector("assessmentAssignForm");

  const {
    handleSubmit,
    pristine,
    reset,
    submitting,
    onSubmit,
    FilterFormFields,
  } = props;
  return (
    <>
      <div className="row">
        <div className="col-12">
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div className="enrollment-form assign-assessment-form pt-5 pb-2">
              <div className="row pb-5 px-3 pt-5">
                <DynamicForm formFields={FilterFormFields} disable={false} />
              </div>
            </div>
            <div className="text-right">
              <Button
                variant="outlined"
                color="secondary"
                className={classes.button}
                onClick={props.onCancel}
              >
                Cancel
              </Button>
              &nbsp;
              <Button
                variant="contained"
                color="secondary"
                className={classes.button}
                type="submit"
                disabled={pristine || submitting}
              >
                Apply
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};
const ReduxFilterForm = reduxForm({
  form: "assessmentAssignForm",
  enableReinitialize: true,
})(FilterForm);

export const FilterAssessmentDrawer = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  let FilterFormFields = [
    {
      FormFieldMetaDataId: 78,
      name: "ClientId",
      validate: null,
      isRequired: true,
      fieldName: "Client",
      isMulti: false,
      DependentOn: null,
      options: [
        {
          Text: "Personal Studies for New Life (PSNL)",
          Value: "1",
        },
        {
          Text: "Advanced Studies for New Life (ASNL)",
          Value: "2",
        },
        {
          Text: "Group Studies for New Life (GSNL)",
          Value: "3",
        },
      ],
      DependentOptions: null,
      checkBoxOptions: null,
      for: null,
      componentType: "ReduxSelect",
      label: "Select Client",
      labelText: "Select Client",
      FiledLength: null,
      format: null,
      normalize: null,
      helperText: null,
      class: "col-12 col-md-6 col-lg-6",
      isDisplayTitle: null,
      Title: null,
      condition: null,
    },
    {
      FormFieldMetaDataId: 82,
      name: "DueDate",
      validate: null,
      isRequired: true,
      fieldName: "PublisheDue DatedDate",
      isMulti: false,
      DependentOn: null,
      options: null,
      DependentOptions: null,
      checkBoxOptions: null,
      for: null,
      componentType: "ReduxDateInput",
      label: "Due Date",
      labelText: "Due Date",
      FiledLength: null,
      format: null,
      normalize: null,
      helperText: null,
      class: "col-12 col-md-6 col-lg-6",
      isDisplayTitle: null,
      Title: null,
      condition: null,
    },
    {
      FormFieldMetaDataId: 621,
      name: "Gender",
      validate: null,
      isRequired: true,
      fieldName: "Gender",
      isMulti: false,
      DependentOn: null,
      options: null,
      DependentOptions: null,
      checkBoxOptions: [
        {
          value: "1",
          text: "All",
          label: "All",
        },
        {
          value: "2",
          text: "Female",
          label: "Female",
        },
        {
          value: "3",
          text: "Male",
          label: "Male",
        },
      ],
      for: null,
      componentType: "CheckboxGroup",
      label: "Gender",
      labelText: "Gender",
      FiledLength: null,
      format: null,
      normalize: null,
      helperText: null,
      class: "col-12 col-md-12 col-lg-12",
      isDisplayTitle: null,
      Title: null,
      condition: null,
    },
    {
      FormFieldMetaDataId: 621,
      name: "ServiceType",
      validate: null,
      isRequired: true,
      fieldName: "Service Type",
      isMulti: false,
      DependentOn: null,
      options: null,
      DependentOptions: null,
      checkBoxOptions: [
        {
          value: "1",
          text: "Detox",
          label: "Detox",
        },
        {
          value: "2",
          text: "Residential",
          label: "Residential",
        },
        {
          value: "3",
          text: "PHP",
          label: "PHP",
        },
        {
          value: "4",
          text: "IOP",
          label: "IOP",
        },
        {
          value: "5",
          text: "OP",
          label: "OP",
        },
        {
          value: "6",
          text: "Family Program",
          label: "Family Program",
        },
        {
          value: "7",
          text: "Alumni",
          label: "Alumni",
        },
        {
          value: "8",
          text: "Telehealth",
          label: "Telehealth",
        },
        {
          value: "9",
          text: "Small Groups",
          label: "Small Groups",
        },
      ],
      for: null,
      componentType: "CheckboxGroup",
      label: "Service Type",
      labelText: "Service Type",
      FiledLength: null,
      format: null,
      normalize: null,
      helperText: null,
      class: "col-12 col-md-12 col-lg-12",
      isDisplayTitle: null,
      Title: null,
      condition: null,
    },
    {
      FormFieldMetaDataId: 621,
      name: "AssessmentStatus",
      validate: null,
      isRequired: true,
      fieldName: "Assessment Status",
      isMulti: false,
      DependentOn: null,
      options: null,
      DependentOptions: null,
      checkBoxOptions: [
        {
          value: "1",
          text: "Overdue",
          label: "Overdue",
        },
        {
          value: "2",
          text: "Completed",
          label: "Completed",
        },
      ],
      for: null,
      componentType: "CheckboxGroup",
      label: "Assessment Status",
      labelText: "Assessment Status",
      FiledLength: null,
      format: null,
      normalize: null,
      helperText: null,
      class: "col-12 col-md-12 col-lg-12",
      isDisplayTitle: null,
      Title: null,
      condition: null,
    },
  ];
  useEffect(() => {
    // dispatch(
    //   smallGroupGet({
    //     SmallGroup: [
    //       {
    //         SmallGroupGuid: props.SmallGroupGuid,
    //       },
    //     ],
    //   })
    // );
  }, []);

  const { smallGroupInfo, SmallGroupData } = useSelector(
    ({ small_group_get: { data: smallGroupData } }) => {
      return {
        SmallGroupData: smallGroupData?.Data?.SmallGroup?.[0] || {},
        smallGroupInfo:
          smallGroupData?.Data?.SmallGroup?.[0]?.SmallGroup?.[0] || {},
      };
    },
    shallowEqual
  );
  const onSubmit = (values) => {
    debugger;
    // let centerId = null;
    // let paramCenterId = getId();
    // if (paramCenterId && paramCenterId > 0) {
    //   centerId = paramCenterId;
    // }
    // let ObjectData = formDataHandler(values);
    // const data = {
    //   Center: [
    //     {
    //       CenterId: centerId ? centerId : null,
    //       ...ObjectData,
    //     },
    //   ],
    // };
    // dispatch(centerUpsert(data));
  };
  return (
    <>
      <div className={`card card-custom`}>
        {/* Head */}
        <div className="card-header border-1">
          <h3>Filter</h3>
          <OverlayTrigger overlay={<Tooltip id="close-tooltip">Close</Tooltip>}>
            <a
              className="btn btn-icon btn-hover-light-primary btn-sm"
              onClick={props.toggleDrawer("right", false, {})}
            >
              <span className="svg-icon svg-icon-md svg-icon-primary">
                <SVG src={toAbsoluteUrl(_Close)} />
              </span>
            </a>
          </OverlayTrigger>
        </div>
        {/* Body */}
        <div className="card-body pt-2 drawer-assessment-filter drawer-details-view">
          <ReduxFilterForm
            onSubmit={onSubmit}
            FilterFormFields={FilterFormFields}
            onCancel={props.toggleDrawer("right", false, {})}
            // initialValues={centerDataInit}
            // centerId={getId()}
          />
        </div>
      </div>
    </>
  );
};
